import { render, staticRenderFns } from "./ComboboxNumber.vue?vue&type=template&id=4e1af092&scoped=true&"
import script from "./ComboboxNumber.vue?vue&type=script&lang=js&"
export * from "./ComboboxNumber.vue?vue&type=script&lang=js&"
import style0 from "./ComboboxNumber.vue?vue&type=style&index=0&id=4e1af092&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1af092",
  null
  
)

export default component.exports